
import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PlaylistUse, UserContext } from '../../Routes/Routes1'
import './options.css'


export default function Options({songData}){
    const {state}=useContext(UserContext)
    const [isPresentInPlaylist,setIsPresentInPlaylist]=useState(false)
    const [playListLoad,setPlayListLoad]=useState(1)
    const {playlistUpdate,setPlaylistUpdate}=useContext(PlaylistUse)

    const navigate=useNavigate()
    const PORT=process.env.REACT_APP_URL_PORT

    useEffect(()=>{
        if(state){
            const USER_STORAGE=JSON.parse(localStorage.getItem("sangeetUser"))
            setIsPresentInPlaylist(false)
            for(let i=0;i<USER_STORAGE.playList.length;i++){
                if(songData._id===USER_STORAGE.playList[i]._id){
                    setIsPresentInPlaylist(true)
                    i=USER_STORAGE.playList.length
                }
                else{
                    setIsPresentInPlaylist(false)
                }
            }
        }
    },[songData,playListLoad,state])

    

    const addToPlayList=songData=>{
        if(state){
            const userData=JSON.parse(localStorage.getItem("sangeetUser"))
            userData.playList.push(songData)
            localStorage["sangeetUser"]=JSON.stringify(userData)

            axios.post(`https://${PORT}/admin/update_user`,userData)
            .then(()=>{
                setPlaylistUpdate(playlistUpdate+1)
                setPlayListLoad(playListLoad+1)
            })
        }
    }

    const removeToPlayList=()=>{
        const USER_STORAGE=JSON.parse(localStorage.getItem("sangeetUser"))
        for(let i=0;i<USER_STORAGE.playList.length;i++){
            if(songData._id===USER_STORAGE.playList[i]._id){
                USER_STORAGE.playList.splice(i,1)
                i=USER_STORAGE.playList.length
            }
        }

        localStorage["sangeetUser"]=JSON.stringify(USER_STORAGE)

        axios.post(`https://${PORT}/admin/update_user`,USER_STORAGE)
        .then(()=>{
            setPlaylistUpdate(playlistUpdate+1)
            setPlayListLoad(playListLoad+1)
        })
    }
    
    


    return (
        <div className="dropdown">
            <button type='button' className=" dotIcon"></button>
            <div className="dropdown-content">
                {
                    state?
                    isPresentInPlaylist?
                    <div className="link" onClick={()=>removeToPlayList(songData)}>Remove to playList</div>:
                    <div className="link" onClick={()=>addToPlayList(songData)}>Add to playList</div>:
                    <div className="link" onClick={()=>navigate('/login')}>Add to playList</div>
             
                }
                
            </div>
            
        </div>
    )
}